import {savePort, saveAuthUrl, saveStatServerUrl} from "../service/localStorageService";

export const setStartDate=(startDate)=>({
   type:'SET_START_DATE',
    startDate
});

export const setEndDate=(endDate)=>({
    type:'SET_END_DATE',
    endDate
});

export const setPath=(path)=>({
    type:'SET_PATH',
    path
});

export const setKey=(key)=>({
    type:'SET_KEY',
    key
});


export const setAuthUrl=(authUrl)=>{
    saveAuthUrl(authUrl);
    return {
        type:'SET_AUTH_URL',
        authUrl
    }
};

export const setStatServerUrl=(statServerUrl)=>{
    saveStatServerUrl(statServerUrl);
    return {
        type:'SET_STAT_SERVER_URL',
        statServerUrl
    }
};

export const setPort=(port)=>{
    savePort(port);
    return {
        type:'SET_PORT',
        port
    }
};

export const addProduct=(product)=>({
    type:'ADD_PRODUCT',
    product
});

export const removeProduct=(product)=>({
    type:'REMOVE_PRODUCT',
    product
});

export const setLimit=(limit)=>({
    type:'SET_LIMIT',
    limit
});

export const ADD_ALL_PRODUCTS = 'ADD_ALL_PRODUCTS';

export const addAllProducts=()=>({
    type: ADD_ALL_PRODUCTS
});

export const CLEAR_PRODUCTS = 'CLEAR_PRODUCTS';

export const clearProducts=()=>({
    type: CLEAR_PRODUCTS
});

export const SET_USERNAME = 'SET USERNAME';

export const setUsername=(username)=>({
    type:SET_USERNAME,
    username
});

export const SET_HARDWARE_ID = 'SET HARDWARE ID';

export const setHardwareId=(hardwareId)=>({
    type:SET_HARDWARE_ID,
    hardwareId
});

export const setClearResults=(key, value)=>({
   type:'SET_CLEAR_RESULTS',
    key,
    value
});

export const setCurPage=(key, value)=>({
    type:'SET_CUR_PAGE',
    key,
    value
});